import Vue from "vue"

Vue.filter("decimal", (value: number, digitsAfterPoint: number) => {
    return value.toFixed(digitsAfterPoint)
})
